<template>
  <section
    class="content"
    v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER,USER_ROLES.REPORT_STAFF,USER_ROLES.SALES_MANAGER]"
  >
    <div>
      <div class="box-body">
        <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER,USER_ROLES.REPORT_STAFF]"
        >
          <button v-if="this.forDelete.length > 0" @click="deleteMultiple" class="btn"><i class="fa fa-trash" aria-hidden="true"></i></button>
          <router-link :to="{ name: 'ReportCreate' }">
            <button class="btn">Generate New</button>
          </router-link>
        </div>
        <v-server-table
          ref="reportgenerationTable"
          url
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
        >
         <template slot="checkbox" slot-scope="props">
            <div>
              <input type="checkbox" :checked="this.deleteIds && this.deleteIds.length > 0 && this.deleteIds.includes(props.row._id)" v-on:change="multiDelete($event,props.row)" />
              
            </div>
          </template>
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>


          <template slot="download" slot-scope="props">
            <div>
              <a role="button"  v-on:click.stop="download(props.row)">Download</a>
            </div>
          </template>
          <template slot="delete" slot-scope="props">
            <div>
              <a role="button"  v-on:click.stop="deleteReport(props.row)">Delete</a>
            </div>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import Config, { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import moment from 'moment';
import {mapState} from 'vuex';
import axios from 'axios';
import swal from 'sweetalert2'
export default {
  name: 'Report',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: null,
      report:{},
      forDelete:[],
      number:0,
      reportgenerationTable: null,
      columns: [
        'checkbox',
        'reportType',
        'downloadType',
        'reportCriterion',
        'startDate',
        'endDate',
        'createdAt',
        'generatedBy',
        'vehicleNo',
        'download',
        'delete'
        
      ],
      options: {
        highlightMatches: true,
        sortable: [
          'reportType',
          'downloadType',
          'startDate',
          'endDate',
          'createdAt',
          'vehicleNo',
          'generatedBy',
        ],
        headings: {
        checkbox: '',
          reportType: 'Report Type',
          downloadType : 'Download Type',
          reportCriterion: 'Report Criterion',
          startDate: 'Report Start Date',
          endDate: 'Report End Date',
          createdAt: 'Generated At',
          generatedBy: 'Generated By',
          vehicleNo : 'Vehicle No.',
          download: 'Download',
          Delete : 'delete'
        },
        templates: {
          reportType(row,query){
            if (query.reportType == 'hcv_ms'){
              return "Data HCV Mother Station"
            }
            else if (query.reportType == 'hcv_dbs'){
              return "Data HCV Daughter Station"
            }
            else if (query.reportType == 'logbook'){
              return "Vehicle Log Book"
            }
            else if (query.reportType == 'dsr'){
              return "Data Sales Report"
            }
          },
          vehicleNo(row, query) {
            if(query.vehicleIdRegNo){
              return query.vehicleIdRegNo
            }
          },
          reportCriterion(row, query) {
            if(query.regionName && query.stationSiteName){
              return `${query.regionName}-${query.stationSiteName}`;
            }
            else if(query.regionName){
              return `${query.regionName}`
            }
            else if(query.stationSiteName){
              return `${query.stationSiteName}`
            }
          },
          startDate(row, query) {
            return moment(query.startDate).format('DD-MM-YYYY');
          },
          endDate(row, query) {
            return moment(query.endDate).format('DD-MM-YYYY');
          },
          createdAt(row, query) {
            return moment(query.createdAt).format('DD-MM-YYYY');
          },
          generatedBy(row,query) {
            return `${query.generatedByFirstName} ${query.generatedByLastName}`
          },
        },
        requestFunction: request => {
          const params = {};
          params.$page = 1;
          params.$limit = 30;
          if(this.user.roleName == "GA Head"){
            params.regionRegionManager = this.user._id
          }
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          }else {
            params.$sort = '-createdAt';
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          this.loading = true;
          return this.$reportgenerationDataRepository
            .list(params)
            .catch(error => {
              this.$snotify.error(
                'Get Report Generation History failed',
                'Error!',
              );
            });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: 1,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.reportgenerationTable) {
        return this.reportgenerationTable.count >
          this.reportgenerationTable.limit ||
          this.reportgenerationTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    ...mapState({
      user: state => state.auth.user
      }),
  
  },
  methods: {
    onLoaded() {
      this.reportgenerationTable = this.$refs.reportgenerationTable;
    },

    multiDelete(e,row){
      if(e.target.checked){
        this.forDelete.push(row)
        this.deleteIds = this.forDelete.map(i => {
          return i._id
        })
      }else{
        this.forDelete = this.forDelete.filter(i => {
          return i._id != row._id
        })
        this.deleteIds.filter(i => {
          i != row._id
        })
      }
    },

    deleteMultiple(){
       this.number = this.forDelete.length
       
       this.deleteIds = this.forDelete.map(item => {
         return {
           _id: item._id,
           hardDelete : false
           }
       })
        swal({
          title: 'Are you sure?',
          text: `This will permanently delete this ${this.number} Report!`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
          if (result.value) {
              this.loading = true
            return axios.delete('/reportgeneration',{
              data : this.deleteIds
            })
            .then((response) => {
              this.forDelete = []
              this.deleteIds = []
              this.$refs.reportgenerationTable.refresh();
              
                this.loading = false;
                return swal(
                    'Deleted!',
                    'Report has been deleted.',
                    'success'
                )
                
            })
            // .then((response) => {
            //     this.loading = false;
            //     this.$router.push('/ga')
            // })
            .catch((error) => {
                this.loading = false;
                this.$snotify.error('Delete report failed', 'Error!')
            })
          }
      })
    },

    deleteReport (row) {
            swal({
                title: 'Are you sure?',
                text: 'This will permanently delete this Report!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.value) {
                    this.reportDelete(row)
                }
            })
        },
        reportDelete (row) {
            this.loading = true
            return this.$reportgenerationDataRepository.deleteOne(row._id)
            .then((response) => {
              this.$refs.reportgenerationTable.refresh();
                this.loading = false;
                return swal(
                    'Deleted!',
                    'Report has been deleted.',
                    'success'
                )
                
            })
            // .then((response) => {
            //     this.loading = false;
            //     this.$router.push('/ga')
            // })
            .catch((error) => {
                this.loading = false;
                this.$snotify.error('Delete report failed', 'Error!')
            })
        },

    download(row){
      if (row.reportType == 'hcv_ms' || row.reportType == 'hcv_dbs'){
          const params = {};
          params.reportType = row.reportType;
          params.downloadType =row.downloadType;
          params.startDate =row.startDate;
          params.endDate =row.endDate;
          params.region =row.region;
          params.station =row.station;
          params.reportCode = row.reportCode;
          axios({
            method: 'get',
            url:  `${Config.serverURI}/report?reportType=${row.reportType}&downloadType=${row.downloadType}&startDate=${row.startDate}&endDate=${row.endDate}&station=${row.station}&region=${row.region}&reportCode=${row.reportCode}`,
            responseType: 'arraybuffer'
          })
          .then((response) => {
            this.forceFileDownload(response,row)
          }) 
          .catch((error) => {
            this.$snotify.error('Report download failed', 'Error!')
          })
        }
        else if (row.reportType=="logbook"){
          const params = {};
          params.reportType = row.reportType;
          params.downloadType =row.downloadType;
          params.startDate =row.startDate;
          params.endDate =row.endDate;
          params.region =row.region;
          params.reportCode = row.reportCode;
          params.vehicleId = row.vehicleId;
          params.allVehicle = row.allVehicle
          if(row.vehicleId){
            axios({
              method: 'get',
              url:  `${Config.serverURI}/report?reportType=${row.reportType}&downloadType=${row.downloadType}&startDate=${row.startDate}&endDate=${row.endDate}&region=${row.region}&reportCode=${row.reportCode}&vehicleId=${row.vehicleId}&allVehicle=${row.allVehicle}`,
              responseType: 'arraybuffer'
            })
            .then((response) => {
              this.forceFileDownload(response,row)
            }) 
            .catch((error) => {
              this.$snotify.error('Report download failed', 'Error!')
            })
          }
          else{
            axios({
              method: 'get',
              url:  `${Config.serverURI}/report?reportType=${row.reportType}&downloadType=${row.downloadType}&startDate=${row.startDate}&endDate=${row.endDate}&region=${row.region}&reportCode=${row.reportCode}&allVehicle=${row.allVehicle}`,
              responseType: 'arraybuffer'
            })
            .then((response) => {
              this.forceFileDownload(response,row)                                                                                                       
            }) 
            .catch((error) => {
              this.$snotify.error('Report download failed', 'Error!')
            })
          }
        }
        else if(row.reportType == "dsr") {
          const params = {};
          params.reportType = row.reportType;
          params.downloadType =row.downloadType;
          params.startDate =row.startDate;
          params.endDate =row.endDate;
          params.region =row.region;
          params.station =row.station;
          params.reportCode = row.reportCode;
          axios({
            method: 'get',
            url:  `${Config.serverURI}/report?reportType=${row.reportType}&downloadType=${row.downloadType}&startDate=${row.startDate}&endDate=${row.endDate}&station=${row.station}&region=${row.region}&reportCode=${row.reportCode}`,
           responseType: 'arraybuffer'
          })
          .then((response) => {
            this.forceFileDownload(response,row)
          }) 
          .catch((error) => {
            this.$snotify.error('Report download failed', 'Error!')
          })
        }
    },
    forceFileDownload(response,row){
      if (row.downloadType == "XLSX"){
      const url = URL.createObjectURL(new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        
      }))
      const link = document.createElement('a')
      link.href = url
      if (row.reportType == "logbook"){
        link.setAttribute('download', `${row.reportCode}.xlsx`)
      }
      else{
        link.setAttribute('download', `${row.stationSiteName}-${row.reportType}.xlsx`)
      }
      document.body.appendChild(link)
      link.click()
    }
    else {
      if (row.downloadType == "PDF"){
      const url = URL.createObjectURL(new Blob([response.data], {
        type: 'application/pdf'
      }))
      const link = document.createElement('a')
      link.href = url
      if (row.reportType == "logbook"){
        link.setAttribute('download', `${row.reportCode}.pdf`)
      }
      else{
        link.setAttribute('download', `${row.stationSiteName}-${row.reportType}.pdf`)
      }
      document.body.appendChild(link)
      link.click()
    }
    }
    },
  }
};
</script>

<style scoped>
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.btn {
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white
}
</style>


// WEBPACK FOOTER //
// Report.vue?6d421780